import { formatNumberString } from "@/utils/format-number-string";
import { cn } from "@/utils/cn";
import { textVariants } from "@/utils/text-variants";
import { memo } from "react";

interface CalorieDifferenceLabelProps {
  value?: number | null;
}

export const CalorieDifferenceLabel = memo(function CalorieDifferenceLabel({
  value,
}: CalorieDifferenceLabelProps) {
  if (value == null || value === 0) return null;

  const label = formatNumberString(value, { plus: "+", minus: "-", units: "kcal" });

  return (
    <p
      className={cn(
        textVariants.footnote,
        "flex items-center justify-center rounded-full bg-[#58348A] px-3 py-2 text-center font-medium text-white",
      )}
    >
      {label}
    </p>
  );
});
